export const apiBaseURL = process.env.REACT_APP_API_BASE;
export const appBaseURL = process.env.REACT_APP_BASE_URL;
export const instagramCallbackURL = process.env.REACT_APP_INSTAGRAM_REDIRECT;
export const isProduction = process.env.SERVER_CATEGORY === 'production';
